import { useCurrentBreakpoint } from '../../components/BreakpointProvider/useCurrentBreakpoint.js';
/**
 * @example usebreakpoint(['xs', 'lg', 'xl']) // true if current breakpoint matches xs or lg and above
 */
export const useBreakpoint = (matches = []) => {
  const currentBreakpoint = useCurrentBreakpoint();
  return matches.includes(currentBreakpoint);
};